/**
 * api接口统一管理
 */
// import {get, post} from './http'
import {get} from './http'

// 选课页面: banner
export function jsbsBanner (params) {
  return new Promise((resolve, reject) => {
    get('/api/app/v2/get_live_course_one', params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}

// 选课页面: 课程列表 Course1
export function jsbsCourse (params) {
  return new Promise((resolve, reject) => {
    get('/api/app/v2/get_live_courses_sideways', params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}

// 选课页面: 免费试听列表 FreeListen
export function jsbsFreeListen (params) {
  return new Promise((resolve, reject) => {
    get('/api/app/v1/get_live_course_free', params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}

// 选课页面: 免费试听列表 FreeListen
export function jsbsPeriods (params) {
  return new Promise((resolve, reject) => {
    get('/api/app/v1/get_live_courses_type', params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}



// WEBPACK FOOTER //
// ./src/request/api.js